// extracted by mini-css-extract-plugin
export default {"root":"KXUz7w","debugBorder":"YbCfZD"};